import React, { useEffect, useState } from 'react'
import NavBar from '../navbar/Navbar'
import Header from '../navbar/Header'
import RoutesAfterLogin from '../../routes/routesWithLogin/Router'
import { useWhatsAppSocket } from '../../hooks/useWhatsAppSocket'
import { AppLoader } from '../../components/shared/Loader'
import { useIsMobile } from '../../hooks/use-mobile'
import { SupportButton } from '../../components/whatsapp/billing/components/SupportButton'
import { useLocation } from 'react-router-dom'

const navbarCloseWidth = '54px'
const navbarOpenWidth = '224px'

const SUPPORT_BUTTON_PATHS = new Set([
  '/whatsapp/billing',
  '/permissions/index',
  '/whatsapp/dashboard',
  '/home/dashboard',
  '/setting/index'
]);

/** Full-height workspaces — must not live inside the scrollable main pane. */
const FILL_HEIGHT_PATHS = new Set(['/whatsapp/chat']);
const FILL_HEIGHT_PATH_PATTERNS = [
  /^\/whatsapp\/workflows\/[^/]+\/edit$/,
  /^\/whatsapp\/workflows\/create\/new$/,
];

function isFillHeightRoute(pathname) {
  return (
    FILL_HEIGHT_PATHS.has(pathname) ||
    FILL_HEIGHT_PATH_PATTERNS.some((pattern) => pattern.test(pathname))
  );
}

const MenuLayout = () => {
  useWhatsAppSocket();
  const isMobile = useIsMobile();
  const location = useLocation();
  const showSupportButton = SUPPORT_BUTTON_PATHS.has(location.pathname);
  const fillHeightRoute = isFillHeightRoute(location.pathname);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isMobile]);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  const handleDrawerClose = () => setOpen(false);

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <>
      <div className="fixed inset-0 flex w-screen h-[100dvh] overflow-hidden">
        {isMobile ? (
          <>
            {open && (
              <button
                type="button"
                aria-label="Close menu overlay"
                className="fixed inset-0 z-30 bg-black/40"
                onClick={handleDrawerClose}
              />
            )}
            <div
              className={`fixed left-0 top-0 z-40 h-[100dvh] transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full'}`}
            >
              <NavBar open={true} />
            </div>
          </>
        ) : (
          <div
            className="flex-shrink-0 h-full transition-all duration-300 overflow-hidden"
            style={{
              width: open ? navbarOpenWidth : navbarCloseWidth
            }}
          >
            <NavBar open={open} />
          </div>
        )}

        <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-slate-50 dark:bg-slate-950">
          <Header
            open={open}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
          />
          <main className="relative z-0 flex min-h-0 flex-1 flex-col overflow-hidden p-3">
            <AppLoader />
            {fillHeightRoute ? (
              <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <RoutesAfterLogin />
              </div>
            ) : (
              <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
                <div className="flex min-h-full w-full flex-col">
                  <RoutesAfterLogin />
                </div>
              </div>
            )}
          </main>
        </div>
      </div>
      {showSupportButton && <SupportButton />}
    </>
  )
}

export default MenuLayout
